import React from 'react';

const Circle = ({ cx, cy, color, mouseEnter, mouseLeave, index }) => (
  <circle
    cx={cx}
    cy={cy}
    r={3}
    fill={color}
    onMouseEnter={() => mouseEnter(cx, cy, index)}
    onMouseLeave={() => mouseLeave()}
  />
);

export default Circle;
